import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchMerchandisings } from "app/pages/Merchandising/merchandisingActionCreators";
import {
	getCategorizedVisibleMerchandisings,
	getOneMerchBannerMerchandising,
} from "app/pages/Merchandising/merchandisingSelector";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import DynamicBlocksRenderer from "./DynamicBlocksRenderer";
import { paymentTypeShape } from "app/utils/propTypes";
import { getAvailablePaymentTerms, shouldShowReasonToBook } from "app/reducers/partnerSelector";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";

const DynamicBlocksRendererContainer = props => {
	return <DynamicBlocksRenderer {...props} />;
};

DynamicBlocksRendererContainer.propTypes = {
	blocks: PropTypes.array,
	dividerComponent: PropTypes.node,
	fetchMerchandisings: PropTypes.func,
	merchandisings: PropTypes.array,
	alternateColors: PropTypes.bool,
	oneMerchBannerMerchandising: PropTypes.object,
	userIsConnected: PropTypes.bool,
	authorizeDividerComponentForMultiBlocks: PropTypes.bool,
	availablePaymentTerms: PropTypes.arrayOf(paymentTypeShape),
	availablePaymentMethods: PropTypes.array,
	shouldShowReasonToBook: PropTypes.bool,
};

const mapStateToProps = state => {
	return {
		userIsConnected: isAuthenticated(state),
		merchandisings: getCategorizedVisibleMerchandisings(state),
		oneMerchBannerMerchandising: getOneMerchBannerMerchandising(state),
		availablePaymentTerms: getAvailablePaymentTerms(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		shouldShowReasonToBook: shouldShowReasonToBook(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ fetchMerchandisings }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DynamicBlocksRendererContainer);
